<template>
    <div class="voip-panel-browser" role="dialog" aria-label="Dial pad">
        <div
            class="voip-panel-browser-close"
            @click="close"
            @keydown.enter="close"
            @keydown.space="close"
            tabindex="0"
            role="button"
            aria-label="Close dialpad"
        >
            <i class="material-icons" aria-hidden="true">keyboard_arrow_down</i>
        </div>

        <div ref="container" class="flex items-center justify-center my-auto">
            <div class="voip-keypad" >
                <div
                    @mouseover="hover = true; activeKey = 1"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 1 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 1)"
                    @keydown.enter="$emit('dtmf', 1)"
                    @keydown.space.prevent="$emit('dtmf', 1)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 1"
                >
                    <span>1</span>
                    <span></span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 2"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 2 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 2)"
                    @keydown.enter="$emit('dtmf', 2)"
                    @keydown.space.prevent="$emit('dtmf', 2)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 2"
                >
                    <span>2</span>
                    <span></span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 3"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 3 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 3)"
                    @keydown.enter="$emit('dtmf', 3)"
                    @keydown.space.prevent="$emit('dtmf', 3)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 3"
                >
                    <span>3</span>
                    <span></span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 4"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 4 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 4)"
                    @keydown.enter="$emit('dtmf', 4)"
                    @keydown.space.prevent="$emit('dtmf', 4)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 4"
                >
                    <span>4</span>
                    <span></span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 5"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 5 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 5)"
                    @keydown.enter="$emit('dtmf', 5)"
                    @keydown.space.prevent="$emit('dtmf', 5)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 5"
                >
                    <span>5</span>
                    <span></span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 6"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 6 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 6)"
                    @keydown.enter="$emit('dtmf', 6)"
                    @keydown.space.prevent="$emit('dtmf', 6)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 6"
                >
                    <span>6</span>
                    <span></span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 7"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 7 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 7)"
                    @keydown.enter="$emit('dtmf', 7)"
                    @keydown.space.prevent="$emit('dtmf', 7)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 7"
                >
                    <span>7</span>
                    <span></span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 8"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 8 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 8)"
                    @keydown.enter="$emit('dtmf', 8)"
                    @keydown.space.prevent="$emit('dtmf', 8)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 8"
                >
                    <span>8</span>
                    <span></span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 9"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 9 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 9)"
                    @keydown.enter="$emit('dtmf', 9)"
                    @keydown.space.prevent="$emit('dtmf', 9)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 9"
                >
                    <span>9</span>
                    <span></span>
                </div>

                <div
                    @mouseover="hover = true; activeKey = 10"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 10 ? $parent.$parent.widget_settings.color : '#B7B7B7' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', '*')"
                    @keydown.enter="$emit('dtmf', '*')"
                    @keydown.space.prevent="$emit('dtmf', '*')"
                    tabindex="0"
                    role="button"
                    aria-label="Star key"
                >
                    <span>*</span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 11"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 11 ? $parent.$parent.widget_settings.color : '#000000' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', 0)"
                    @keydown.enter="$emit('dtmf', 0)"
                    @keydown.space.prevent="$emit('dtmf', 0)"
                    tabindex="0"
                    role="button"
                    aria-label="Number 0"
                >
                    <span>0</span>
                    <span></span>
                </div>
                <div
                    @mouseover="hover = true; activeKey = 12"
                    @mouseleave="hover = false; activeKey = null"
                    :style="{ color: hover && activeKey === 12 ? $parent.$parent.widget_settings.color : '#B7B7B7' }"
                    class="voip-keypad-key"
                    @click="$emit('dtmf', '#')"
                    @keydown.enter="$emit('dtmf', '#')"
                    @keydown.space.prevent="$emit('dtmf', '#')"
                    tabindex="0"
                    role="button"
                    aria-label="Pound key"
                >
                    <span>#</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                term: null,
                hover: false,
                activeKey: null
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
        }
    }
</script>
